/**
 * Default values for fields that should always be set to their "max" (most
 * thorough / always-on) option. These are factory-mandated finishing details
 * that the tailor never wants to forget — e.g., heel guards, brand labels,
 * seam tolerances — and we surface them via auto-defaulting + the
 * `useApplyStyleDefaults` hook below.
 *
 * For each field, the value is the verbatim `value` stored in `rc_codes` so
 * the dropdown picks it up and shows the matching code badge automatically.
 */

export const JACKET_MAX_DEFAULTS = {
  sleeve_seam_adjustment: "Outer sleeve length seam 1.5cm (uneven seam, customer accepts)", // C-05N4
  pocket_seam_fabric:     "out below pocket seam thread and bottom fabrics appointed by customers-", // C-0665
  origin_label_position:  "No origin label",                                                 // C-088E
  brand_label_position:   "Logo pinned 6.5cm below left pocket (Lyussic)",                   // C-09GM
  back_side_seam:         "Back side seam 3.0cm",                                            // C-05N6 (bigger amount)
};

export const PANT_MAX_DEFAULTS = {
  pant_back_center_seam:      "Back waist seam type-I open flat knot fixation",                       // T-335B
  pant_seam_requirement:      "Inner back-piece seam 1.0cm (knee/crotch increase not repairable, customer accepts)", // T-372F
  pant_heel_guard:            "Whole circle heel guard belt at pant bottom",                          // T-3614
  pant_brand_position:        "Brand label in center of back waistband (Lyussic)",                    // T-364A
  pant_origin_label_position: "No origin label",                                                       // T-3662
};

// Pant Tuxedo activates these (in addition to existing tuxedo defaults)
export const PANT_TUXEDO_FRONT_POCKET_OPENING = "Satin for besom or welt of front pockets"; // T-314P
